
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_e66ui_145",
  "focus-lock": "awsui_focus-lock_145pa_e66ui_177",
  "calendar": "awsui_calendar_145pa_e66ui_181",
  "date-picker-container": "awsui_date-picker-container_145pa_e66ui_197",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_e66ui_202",
  "date-picker-input": "awsui_date-picker-input_145pa_e66ui_206",
  "open-calendar-button": "awsui_open-calendar-button_145pa_e66ui_211"
};
  